import React, { useEffect, useState } from 'react';
import api from '../api';

const AdminMonitoringPembayaran = () => {
    const [pembayaranList, setPembayaranList] = useState([]);
    const [events, setEvents] = useState([]);
    const [page, setPage] = useState(0);
    const [size, setSize] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [totalElements, setTotalElements] = useState(0);
    const [searchColumn, setSearchColumn] = useState("nomorReferensi");
    const [searchValue, setSearchValue] = useState("");
    const [verifyingId, setVerifyingId] = useState(null);
    const apiUrl = process.env.REACT_APP_API_ENDPOINT;

    // Fetch list event (sekali saat load)
    useEffect(() => {
        api.get(`${apiUrl}/api/public/events`)
            .then(res => setEvents(res.data))
            .catch(err => console.error(err));
    }, [apiUrl]);

    // Fetch data pembayaran berdasarkan search atau tidak
    useEffect(() => {
        let url = `${apiUrl}/api/admin/pembayaran-page?page=${page}&size=${size}`;
        if (searchValue.trim() !== "") {
            url = `${apiUrl}/api/admin/pembayaran-search?page=${page}&size=${size}&column=${searchColumn}&value=${encodeURIComponent(searchValue.trim())}`;
        }

        api.get(url)
            .then(res => {
                setPembayaranList(res.data.content);
                setTotalPages(res.data.totalPages);
                setTotalElements(res.data.totalElements);
            })
            .catch(err => console.error(err));
    }, [apiUrl, page, size, searchColumn, searchValue, verifyingId]);

    // Ubah ukuran halaman
    const setPageListItems = (event) => {
        const value = parseInt(event.target.getAttribute('data-value'), 10);
        setSize(value);
        setPage(0);
    };

    // Verifikasi
    const handleVerify = async (id) => {
        if (!window.confirm('Verifikasi pembayaran ini?')) return;
        try {
            await api.put(`${apiUrl}/api/admin/verify-pembayaran/${id}`);
            setVerifyingId(id); // Trigger reload data
        } catch (err) {
            alert('Gagal verifikasi!');
        }
    };

    return (
        <div className="page-wrapper">
            <div className="page-header d-print-none">
                <div className="container-xl">
                    <h2 className="page-title">
                        Monitoring Pembayaran Peserta <span className="text-muted">- Admin</span>
                    </h2>
                </div>
            </div>

            <div className="page-body">
                <div className="container-xl">
                    <div className="card">
                        <div className="card-header">
                            <div className="row mb-2">
                                <div className="col-auto">
                                    <select className="form-select" value={searchColumn} onChange={e => setSearchColumn(e.target.value)}>
                                        <option value="nomorReferensi">Nomor Referensi</option>
                                        <option value="norek">No. Rekening</option>
                                        <option value="bank">Bank</option>
                                        <option value="atasNama">Atas Nama</option>
                                        <option value="tglPembayaran">Tanggal Pembayaran</option>
                                        <option value="status">Status</option>
                                        <option value="username">Username</option>
                                    </select>
                                </div>
                                <div className="col">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Cari..."
                                        value={searchValue}
                                        onChange={e => { setSearchValue(e.target.value); setPage(0); }}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="table-responsive">
                            <table className="table card-table table-vcenter text-nowrap datatable table-hover">
                                <thead>
                                    <tr>
                                        <th>No</th>
                                        <th>Event</th>
                                        <th>Nomor Rekening</th>
                                        <th>Nama Bank</th>
                                        <th>Atas Nama</th>
                                        <th>Tanggal Pembayaran</th>
                                        <th>Nomor Referensi</th>
                                        <th>Bukti</th>
                                        <th>Status</th>
                                        <th>Peserta</th>
                                        <th>Aksi</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {pembayaranList.length === 0 ? (
                                        <tr>
                                            <td colSpan={11} className="text-center">Data tidak ditemukan</td>
                                        </tr>
                                    ) : pembayaranList.map((item, idx) => (
                                        <tr key={item.id || idx}>
                                            <td>{page * size + idx + 1}</td>
                                            <td>{item.event?.eventCode} - {item.event?.title}</td>
                                            <td>{item.norek}</td>
                                            <td>{item.bank}</td>
                                            <td>{item.atasNama}</td>
                                            <td>{item.tglPembayaran}</td>
                                            <td>{item.nomorReferensi}</td>
                                            <td>
                                                {item.buktiPath && (
                                                    <a
                                                        href={`${apiUrl}/api/public/displayimage/${item.buktiPath}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Lihat
                                                    </a>
                                                )}
                                            </td>
                                            <td>
                                                <span className={`badge bg-${item.status === 'VERIFIED' ? 'green' : item.status === 'REJECTED' ? 'red' : item.status === 'PENDING' ? 'yellow' : 'gray'}`}>
                                                    {item.status}
                                                </span>
                                            </td>
                                            <td>{item.username?.fullname || item.username?.username}</td>
                                            <td>
                                                {item.status === 'PENDING' && (
                                                    <button className="btn btn-sm btn-success" onClick={() => handleVerify(item.id)}>
                                                        Klik untuk Verifikasi
                                                    </button>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <div className="card-footer d-flex align-items-center">
                            <div className="dropdown">
                                <a className="btn dropdown-toggle" data-bs-toggle="dropdown">
                                    <span className="me-1">{size}</span>
                                    <span>records</span>
                                </a>
                                <div className="dropdown-menu">
                                    {[2, 10, 20, 50, 100].map(val => (
                                        <a className="dropdown-item" onClick={setPageListItems} data-value={val} key={val}>
                                            {val} records
                                        </a>
                                    ))}
                                </div>
                            </div>
                            <ul className="pagination m-0 ms-auto">
                                <li className={`page-item${page === 0 ? ' disabled' : ''}`}>
                                    <a className="page-link" href="#" onClick={e => { e.preventDefault(); if (page > 0) setPage(page - 1); }}>prev</a>
                                </li>
                                {[...Array(totalPages)].map((_, idx) => (
                                    <li key={idx} className={`page-item${page === idx ? ' active' : ''}`}>
                                        <a className="page-link" href="#" onClick={e => { e.preventDefault(); setPage(idx); }}>{idx + 1}</a>
                                    </li>
                                ))}
                                <li className={`page-item${page === totalPages - 1 ? ' disabled' : ''}`}>
                                    <a className="page-link" href="#" onClick={e => { e.preventDefault(); if (page < totalPages - 1) setPage(page + 1); }}>next</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminMonitoringPembayaran;
